import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../api";

export default function Login() {
  const [email, setEmail] = useState("max@maxvalle.it");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("mv_token", data.token);
      navigate("/");
    } catch (err) {
      setError(err.response?.data?.detail || "Errore di accesso");
    } finally { setLoading(false); }
  };

  return (
    <div className="login-page">
      <div className="login-card" data-testid="login-card">
        <div className="flex items-center gap-3 mb-6">
          <div style={{width:48,height:48,borderRadius:10,background:"var(--mv-primary)",color:"white",display:"flex",alignItems:"center",justifyContent:"center",fontWeight:800,fontSize:24}}>M</div>
          <div>
            <div style={{fontWeight:800,fontSize:20,color:"var(--mv-primary)"}}>Max Valle LeadGen</div>
            <div className="text-small text-muted">Piattaforma interna lead B2B</div>
          </div>
        </div>
        <form onSubmit={submit}>
          <label className="label">Email</label>
          <input className="input" type="email" value={email} onChange={e=>setEmail(e.target.value)} required data-testid="login-email" />
          <div style={{height:14}} />
          <label className="label">Password</label>
          <input className="input" type="password" value={password} onChange={e=>setPassword(e.target.value)} required data-testid="login-password" />
          {error && <div className="badge badge-red mt-4" style={{display:"block",padding:"10px 14px",borderRadius:8}} data-testid="login-error">{error}</div>}
          <button className="btn btn-primary w-full mt-6" disabled={loading} data-testid="login-submit">
            {loading ? <span className="spinner" /> : "Accedi"}
          </button>
        </form>
        <div className="text-small text-muted text-center mt-6">
          Accesso riservato — Single user
        </div>
      </div>
    </div>
  );
}
